import { render, staticRenderFns } from "./DadosPage.vue?vue&type=template&id=f2dcd25e&"
import script from "./DadosPage.vue?vue&type=script&lang=js&"
export * from "./DadosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports